export const environment = {
	production: true,
	hmr: false,

	APP_ENV: 'master',
	COMMIT_HASH: 'f8b02d76b9940a33ed84c83ceb9ed1972120db2a',
	API_URL: '/',
	PROMO_START: '2019-01-01 00:00:00',
	PROMO_END: '2019-01-31 23:59:59',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts